import type { Values } from '@web-platform/shared-universal-types-utils/src/utils';

export const FLIGHT_PQS = 'FLIGHT_PQS';

export const MINIMUM_NUMBER_OF_HOTELS_TO_DISPLAY = 2;

export const SIMFEROPOL_ENTITY_ID = '27546352';

export const DEFAULT_PARTNER = 'Trip.com';

export const HOTEL_DISCOUNT_TYPE = {
  unset: 0,
  direct: 2,
} as const;

export const HOTEL_RATE_TYPES = {
  flightSearch: 'flight_search',
  flightCustomer: 'flight_customer',
  flightBooked: 'flight_booked',
  hotelSearch: 'hotel_search',
  hotDeal: 'hot_deal',
  hotelBooked: 'hotel_booked',
  hotelCustomer: 'hotel_customer',
  carSearch: 'car_search',
  carBooked: 'car_booked',
  carCustomer: 'car_customer',
  general: 'general',
  business: 'business',
  loyalty: 'loyalty',
  mobile: 'mobile',
  loggedIn: 'logged_in',
  directDiscount: 'direct_discount',
  coupon: 'coupon',
} as const;

type HOTEL_RATE_TYPE_VALUES = Array<Values<typeof HOTEL_RATE_TYPES>>;

export const HOTEL_GREAT_SAVING_RATE_TYPES: HOTEL_RATE_TYPE_VALUES = [
  HOTEL_RATE_TYPES.flightSearch,
  HOTEL_RATE_TYPES.flightCustomer,
  HOTEL_RATE_TYPES.flightBooked,
  HOTEL_RATE_TYPES.hotelSearch,
  HOTEL_RATE_TYPES.hotDeal,
  HOTEL_RATE_TYPES.hotelBooked,
  HOTEL_RATE_TYPES.hotelCustomer,
  HOTEL_RATE_TYPES.carSearch,
  HOTEL_RATE_TYPES.carBooked,
  HOTEL_RATE_TYPES.carCustomer,
];

export const HOTEL_HIDDEN_RATE_TYPES: HOTEL_RATE_TYPE_VALUES = [
  HOTEL_RATE_TYPES.general,
  HOTEL_RATE_TYPES.business,
  HOTEL_RATE_TYPES.loyalty,
];

export const HOTEL_DISCOUNT_RATE_TYPES: HOTEL_RATE_TYPE_VALUES = [
  HOTEL_RATE_TYPES.mobile,
  HOTEL_RATE_TYPES.loggedIn,
  HOTEL_RATE_TYPES.general,
];

export const HOTEL_SAVE_RATE_TYPES: HOTEL_RATE_TYPE_VALUES = [
  HOTEL_RATE_TYPES.flightSearch,
  HOTEL_RATE_TYPES.flightCustomer,
  HOTEL_RATE_TYPES.flightBooked,
  HOTEL_RATE_TYPES.hotelSearch,
  HOTEL_RATE_TYPES.hotDeal,
  HOTEL_RATE_TYPES.hotelBooked,
  HOTEL_RATE_TYPES.hotelCustomer,
  HOTEL_RATE_TYPES.carSearch,
  HOTEL_RATE_TYPES.carBooked,
  HOTEL_RATE_TYPES.carCustomer,
  HOTEL_RATE_TYPES.directDiscount,
];
